import apiClient from './apiClient';

export interface AdminStats {
  totalProducts: number;
  totalCustomers: number;
  pendingOrders: number;
  monthlyRevenue: number;
  lowStockItems: number;
  completedDeliveries: number;
}

export interface RecentOrder {
  id: string;
  customerName: string;
  items: string;
  amount: number;
  status: 'pending' | 'processing' | 'shipped' | 'delivered' | string;
  date: string | null;
}

export interface LowStockItem {
  id: string;
  name: string;
  currentStock: number;
  minStock: number;
  category: string;
}

export interface AdminDashboardSummary {
  stats: AdminStats;
  recentOrders: RecentOrder[];
  lowStockItems: LowStockItem[];
}

export const fetchAdminDashboardSummary = async (): Promise<AdminDashboardSummary> => {
  const response = await apiClient.get('/admin/dashboard/summary');
  return response.data;
};
